import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import EventSkillOverviewTable from "../../components/event/EventSkillOverviewTable";
import EventScoreOverviewSection from "../../components/app/EventScoreOverviewSection";

export default function TestEventOverviewComponent() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    // setValue(1234);

    let memberResultData = [
        {
            "member_id": 29113,
            "group": "1A",
            "group_num": "01",
            "display_name": "Annie Fu",
            "total_rank_score": 10,
            "is_completed": true,
            "skill_data": [
                {
                    "skill_code": "fit_situp",
                    "rank": 5,
                    "rank_score": 5,
                    "skill_score": 30
                },
                {
                    "skill_code": "fit_sitnreach",
                    "rank": 2,
                    "rank_score": 2,
                    "skill_score": 20
                },
                {
                    "skill_code": "fit_15mrun",
                    "rank": 1,
                    "rank_score": 1,
                    "skill_score": 7
                },
                {
                    "skill_code": "fit_handgrip",
                    "rank": 2,
                    "rank_score": 2,
                    "skill_score": 15
                }
            ]
        },
        {
            "member_id": 29114,
            "group": "1B",
            "group_num": "002",
            "display_name": "Sam Wong",
            "total_rank_score": 0,
            "is_completed": false,
            "skill_data": []
        }
    ]

    let skillInfoList = [
        {
            "skill_code": "fit_situp",
            "skill_name_en": "1 min Sit-up",
            "skill_name_zh": "體適能 - 1分鐘仰臥起坐",
            "display_name": "體適能 - 1分鐘仰臥起坐",
            "unit": "time"
        },
        {
            "skill_code": "fit_sitnreach",
            "skill_name_en": "Sit and Reach",
            "skill_name_zh": "體適能 - 坐前伸",
            "display_name": "體適能 - 坐前伸",
            "unit": "cm"
        },
        {
            "skill_code": "fit_15mrun",
            "skill_name_en": "15m run",
            "skill_name_zh": "體適能 - 15米漸進式心肺耐力跑",
            "display_name": "體適能 - 15米漸進式心肺耐力跑",
            "unit": "round"
        },
        {
            "skill_code": "fit_handgrip",
            "skill_name_en": "Hand Grip",
            "skill_name_zh": "體適能 - 手握力",
            "display_name": "體適能 - 手握力",
            "unit": "kg"
        }
    ]
    let event = {
        "id": 124,
        "name_en": "體適能25/26 #1",
        "name_zh": "體適能25/26 #1",
        "type": "org",
        "organization_id": 154,
        "start_at": "2025-10-20 04:55:15",
        "end_at": "2025-10-24 16:00:00",
        "participant_org": [
            154
        ],
    }

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Simple</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>
                <EventScoreOverviewSection event={event} />
                <EventSkillOverviewTable memberResultData={memberResultData}
                    skillList={skillInfoList} />
            </Stack>
        </Container>
    )
}
